<template>
  <div class="text-center d-flex align-center">
    <!-- MENU PERFIL -->
    <v-menu v-model="menuPerfil" min-width="250px" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-avatar color="#086318" size="36" v-bind="attrs" v-on="on" class="mr-2">
          <span class="white--text text-h6">{{ resource.initials }}</span>
        </v-avatar>
      </template>

      <v-card>
        <v-list-item-content class="justify-center">
          <div class="pa-5 text-left">
            <div class="box">
              <v-avatar color="green" class="mr-2" size="26">
                <span class="white--text">{{ resource.initials }}</span>
              </v-avatar>
              <div class="box-name">
                <small class="saudacao">Olá,</small>
                <h5>{{ resource.fullName }}</h5>
              </div>
            </div>

            <div class="box-infos">
              <span>Email</span>
              <span class="text-caption mt-1">
                {{ resource.email }}
              </span>
            </div>

            <div class="box-btn-actions text-center">
              <v-divider class="my-3"></v-divider>
              <NewPass :resource="btnName" />
              <v-divider class="my-3"></v-divider>
              <v-btn depressed rounded text @click="logout">
                Desconectar
              </v-btn>
            </div>
          </div>
        </v-list-item-content>
      </v-card>
    </v-menu>

    <v-menu
      v-model="menuAlertas"
      min-width="300px"
      offset-y
      v-if="showAlertsMenu"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          style="position: relative; display: inline-block"
        >
          <v-avatar color="#3a995a" size="36">
            <v-icon class="white--text text-h6">mdi-bell</v-icon>
          </v-avatar>

          <v-badge
            v-if="Number(alertQuantity) >= 1"
            :content="alertQuantity"
            color="red"
            overlap
            offset-x="12"
            offset-y="12"
            style="position: absolute; top: 0; right: 0"
          />
        </div>
      </template>

      <v-card class="mx-auto rounded-lg" max-width="auto" elevation="1">
        <v-list flat>
          <div>
            <v-list-item
              class="d-flex justify-center"
              v-for="(item, i) in alerts"
              :key="i"
              @click.stop="viewAlert(item.id)"
            >
              <div
                class="pr-6 pl-6 pt-4 pb-4 mb-2"
                style="
                  border: 1px solid #ccc;
                  border-radius: 15px;
                  width: 280px;
                  display: block;
                  word-wrap: break-word;
                "
              >
                <v-icon
                  class="mr-2"
                  :color="item.viewed != 0 ? 'green' : undefined"
                >
                  {{
                    item.viewed == 0
                      ? "mdi-checkbox-multiple-blank-circle-outline"
                      : "mdi-checkbox-multiple-marked-circle"
                  }}
                </v-icon>
                <small>{{ item.messages }}</small>
              </div>
            </v-list-item>
          </div>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import axios from "@/axios";
import NewPass from "../login/NewPassword-comp.vue";
import currentUser from "@/utils/currentUser";
import { profileSlug } from "@/helpers/profileSlug";
export default {
  data() {
    return {
      btnName: "ALTERAR SENHA",
      alertQuantity: "",
      alerts: [],
      menuPerfil: false,
      menuAlertas: false,
    };
  },
  props: {
    resource: {
      type: Object,
    },
  },
  components: {
    NewPass,
  },
  mounted() {
    this.checkAlerts();
  },
  watch: {
    menuPerfil(val) {
      if (val) this.menuAlertas = false;
    },
    menuAlertas(val) {
      if (val) this.menuPerfil = false;
    },
  },
  computed: {
    profile() {
      const userData = currentUser.getUserData() 
        return userData.profile
    },

    showAlertsMenu() { 
      const profile_slug =  profileSlug(this.profile) 
      return [
        'gestor_hemoba',
        'plantonista_cet_coset',
        'tec_hemoba_imuno',
        'tec_hemoba_sorologia',
      ].includes(profile_slug)
    },
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      this.$router.push("/");
    },

    checkAlerts() {
      axios.get(`/alerts`).then((response) => {
        this.alertQuantity = response.data.new >= 1 ? response.data.new : "";
        this.alerts = response.data.alert;
      });
    },

    viewAlert(id) {
      let data = new Object();
      data.id = id;

      axios.post(`/alerts/viewed`, data).then(() => {
        this.checkAlerts();
      });
    },
  },
};
</script>
<style>
.v-menu__content {
  box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px !important;
}
.box {
  display: flex;
  align-items: center;
}

.box-infos {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.box-infos > span {
  font-size: 12px;
  margin-bottom: -3px;
  font-weight: 600;
}

.box-name {
  display: flex;
  flex-direction: column;
}

.box-name > small {
  font-size: 11px;
}

.box-name > h5 {
  font-size: 14px;
}
</style>
